module.exports = __webpack_public_path__ + "img/prosafety_login_image_text.2caec576.svg";